import { ENV } from "@/ENV";
import isModifierSet from "./userModifier";
import { ModifierType } from "./userModifierEnum";
import store from "@/store";

export function isIntern() {
  return ENV.VITE_APP_INSTANCE_KEY === "intern";
}

export function isProduction() {
  return isIntern() || import.meta.env.MODE === "production";
}

export function isDevelopment() {
  return import.meta.env.MODE === "development";
}

export function isTestInstance() {
  return document.location.hostname.endsWith("preview.lisapp.de");
}

/**
 * Checks if only visible for internal use
 * Visible instances localhost, dev, intern
 * Visible User (userId: 1 aka LisaAdmin)
 * @returns boolean to get special admin rights
 */
export function isSpecialAdmin(ignoreInstance = false) {
  return (
    !isModifierSet(ModifierType.ignoreSpecialAdmin) &&
    (store.getters["login/userId"] === 1 ||
      (!ignoreInstance && isIntern()) ||
      document.location.hostname === "localhost")
  );
}
